<template>
  <div class="convention-hall page">
    <van-nav-bar class="nav-bar" :title="$t('账户明细')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="convention-item">
      <van-tabs v-model="active" :swipeable="true" animated line-width="100px" sticky @change="onChange">
        <van-tab name="recharge" :title="$t('accountDetailTab.充值')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-empty v-if="rechargeList.length === 0" :description="$t('数据为空') + '！'"/>
            <div class="recharge-list">
              <div v-for="(v,key) in rechargeList" :key="key" class="recharge-item">
                <div class="money">
                  <div>{{ $t('金额') }}：</div>
                  <div>+{{ v.money }}</div>
                </div>
                <div class="time">
                  <div>{{ $t('时间') }}：</div>
                  <div>{{ v.create_time }}</div>
                </div>
                <div class="money">
                  <div>{{ $t('备注') }}：</div>
                  <div>{{ v.desc }}</div>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab name="withdraw" :title="$t('accountDetailTab.提现')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-empty v-if="withdrawList.length === 0" :description="$t('数据为空') + '！'"/>
            <div v-for="(v,key) in withdrawList" v-else :key="key" class="item_list">
              <div class="topInfo">
                <span v-if="v.status === 2" style="color: #07c160">{{ v.status_text }}</span>
                <span v-else>{{ v.status_text }}</span>
                <span>{{ $t('金额') }}：-{{ v.money }}</span>
              </div>
              <div class="desc">
                <span>{{ $t('说明') }}：{{ v.desc }}</span>
              </div>
              <div class="time">
                <span>{{ $t('提交时间') }}：{{ v.create_time }}</span>
              </div>
              <div class="time">
                <span>{{ $t('审核时间') }}：{{ v.update_time }}</span>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab name="vote" :title="$t('accountDetailTab.投票')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-empty v-if="voteList.length === 0" :description="$t('数据为空') + '！'"/>
            <div class="vote-list">
              <div v-for="(v,key) in voteList" :key="key" class="vote-item">
                <div class="vote-info">
                  <div class="expect">{{ v.expect }}</div>
                  <div>{{ $t('提交时间') }}：{{ v.create_time }}</div>
                  <div>{{ $t('结算时间') }}：{{ v.update_time }}</div>
                </div>
                <div :style="{color: v.result > 0 ? '#07c160' : '#f00'}" class="vote-result">
                  {{ v.result > 0 ? '+' : '' }}{{ v.result }}
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";

export default {
  data() {
    return {
      loading: false,
      finished: false,
      isLoading: false,
      active: 'recharge',
      refreshing: false,
      count: 0,
      page: 1,
      rechargeList: [],
      withdrawList: [],
      voteList: [],
    };
  },
  methods: {
    onChange() {
      this.number = 0;
      this.page = 1;
      this.count = 0;
      this.onLoad();
    },
    getRechargeList() {
      this.$http({
        method: 'get',
        url: 'member_recharge_list',
        data: {page: 1}
      }).then(res => {
        console.log("=>(AccountDetail.vue:73) res", res);
        this.rechargeList = res.data.data;
      });
    },
    getWithdrawList() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawList = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getVoteList() {
      this.$toast.loading({message: this.$t('Loading...'), duration: 0})
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {


          this.voteList = res.data.map(item => {
          let result = 0 - item.money;

            // 循环GameInfo.data，如果win_text === 盈利，在总金额result上加上当前循环的profit，否则就在result上减去当前循环的profit
            item.data.map(item => {
              if (item.win_text === '盈利') {
                result += parseFloat(Number(item.profit).toFixed(2));
              }
            });
            item.result = result.toFixed(2);
            console.log("=>(AccountDetail.vue:141) item.result", item.result);
            return item;
          })


        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).finally(() => {
        this.$toast.clear();
      })
    },
    onLoad() {
      console.log("=>(AccountDetail.vue:104) this.active", this.active);
      if (this.active === 'recharge') {
        this.getRechargeList();
      }
      if (this.active === 'withdraw') {
        this.getWithdrawList();
      }
      if (this.active === 'vote') {
        this.getVoteList();
      }
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false;
        if (this.rechargeList.length === this.count) {
          this.finished = true;
        }
        this.finished && clearTimeout(timer);//清除计时器
      }, 500);
    },
    onRefresh() {
      setTimeout(() => {
        this.onLoad();
        this.page = 1;
        this.finished = false;
        this.loading = true;
        this.isLoading = false;
        Toast(this.$t("刷新成功") + '！');
      }, 500);
    },
  },
  created() {
    this.onLoad();
  }
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}

.nav-bar {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #fff;
}

::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
}

::v-deep .van-tabs__line {
  background-color: #7e5678;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child {
  float: right;
}

.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.vote-list {
  .vote-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    margin: 0;
    padding: 20px 30px;
    border-bottom: 1px solid #eeeeee;

    .vote-info {
      font-size: 23px;
      font-weight: 500;
      color: #000;

      .expect {
        color: #FE2B45;
        font-size: 34px;
        font-weight: bold;
      }
    }

    .vote-result {
      font-size: 34px;
      font-weight: bold;
      color: #FE2B45;
    }
  }
}

.recharge-list {
  background-color: #fff;

  .recharge-item {
    background-color: #fff;
    margin: 10px 30px;
    padding: 20px;
    border-radius: 10px;

    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      font-size: 26px;
      color: #666;

      &:first-child {
        font-size: 34px;
        font-weight: bold;
        color: #000;

        & > div:first-child {
          color: #DAB69C;
        }

        & > div:last-child {
          color: #11C366;
        }
      }
    }
  }
}


</style>
